<template>
  <div class="search-by-cabin">
    <b-form-select
      v-model="cabin"
      :options="cabin_options"
      value-field="value"
      text-field="text"
      @change="handle_change"
    ></b-form-select>
  </div>
</template>

<script>
export default {
  name: 'search-by-cabin',
  created() {
    document.body.classList.remove('overflow-hidden');
  },
  computed: {
    cabin: {
      get() {
        return this.$store.state.liveflight.cabin !== undefined
          ? this.$store.state.liveflight.cabin
          : '';
      },
      set(value) {
        this.$store.commit('cabin', value);
      },
    },
  },
  data() {
    return {
      cabin_options: [
        {
          value: '',
          text: 'Classe (tutte)',
        },
        {
          value: 'ECONOMY',
          text: 'Economy',
        },
        {
          value: 'PREMIUM_ECONOMY',
          text: 'Premium economy',
        },
        {
          value: 'BUSINESS',
          text: 'Business',
        },
        {
          value: 'FIRST',
          text: 'First',
        },
      ],
    };
  },
  methods: {
    handle_change() {
      //this.log('[CHANGE]: cabin = '+this.cabin)
      window.eventBus.$emit('change-search-by', { cabin: this.cabin });
    },
  },
};
</script>

<style lang="scss">
.search-by-cabin {
  @include liveflight-select;
}
</style>
